import $ from 'jquery';
import Handlebars from 'handlebars';
import tdaConfig from 'lib/util/tda.config';
import inventoryService from 'lib/services/inventory-service';
import inventoryXform from 'lib/transforms/inventory';
import inventoryStandardFeaturesXform from 'lib/transforms/inventory.standardFeatures';
import inventoryDetailXform from 'lib/transforms/inventory.detail';
import Slicker from 'components/slicker';
import enableFeatureExpanders from 'lib/util/feature-expanders';
import responsive from 'lib/responsive';
import compare from 'features/ctas/compare.cta';
import dealerSite from 'features/ctas/dealer.site.cta';
import raq from 'features/ctas/raq.cta';
import inventory from 'features/ctas/inventory.cta';
import dealBuilder from 'features/ctas/deal.builder.cta';
import offers from 'features/ctas/offers.cta';
import disclaimersService from 'components/disclaimers';
import txtTemplate from './offer.additional.inv.hbs';
import txtTemplateModal from './offer.additional.inv.modal.hbs';
import txtCtas from 'tmpl/ctas.hbs';
import ctaXform from 'lib/transforms/tools.dcr.ctas';
import scroll from 'lib/scroller';
import blocks from 'lib/analytics/blocks/index';
import anAddContext from 'lib/analytics/context.add';
import anComponentView from 'lib/analytics/componentView';
import anClicks from 'lib/analytics/click';
import 'lib/helpers/replace';
import 'lib/helpers/if_eq';

var __tmplInv = Handlebars.compile(txtTemplate);
var __tmplInvModal = Handlebars.compile(txtTemplateModal);
var __tmplCtas = Handlebars.compile(txtCtas);
var __availableListlistDrawn = false;
var __additionalInventoryDisplayCount = 4;
var __additionalInventoryItems = [];
var __regionCode = tdaConfig.inventory.region_code;
var __offerSeries;
var __seriesYear;
var __regexDisclaimer = /(\[)([^\]]+)(\])/g;

var additionalInventory = {
  init: function (config) {
    this.i18n = config.i18n;
    this.ctas = ctaXform(config.params.ctas);
    Handlebars.registerPartial('ctasInv', __tmplCtas({ ctas: this.ctas }));
  },

  draw: function (currentOffer) {
    var self = this;
    self.currentOffer = currentOffer;

    // SIDE STEPPING THE isSingleSeries to show something for additional inventory.
    if ($('div[data-series]').length) {
      __offerSeries = currentOffer.model.code;
      __seriesYear = $('div[data-seriesyear]').data().seriesyear || currentOffer.model.year;

      // GET THE FIRST 8 VEHICLES BASED ON SERIES. ( FOR MULTI WE ARE SELECTING THE 0 item.)
      inventoryService.inventory().getInventory({
        pagesize: 8,
        filter: {
          region: [__regionCode],
          series: [__offerSeries],
          year: [__seriesYear]
        }
      })
        .then(function (res) {
          // 1. xform into cards.
          var xformedCards = inventoryXform({ data: res });
          // 2. add standardFeatures to each card
          var returnList = [];
          for (var x = 0; x < xformedCards.length; x += 1) {
            var tempCard = xformedCards[x];
            var tempObj = inventoryDetailXform(tempCard);
            var standard = res.body.response.standardfeatures;
            var noStandards = $.isEmptyObject(standard);
            if (noStandards) {
              tempObj.features = [{
                title: 'Error',
                content: ['Unable to retrieve standard features']
              }];
            } else {
              tempObj.features = inventoryStandardFeaturesXform([tempCard], standard)[0].features;
            }
            returnList.push(tempObj);
          }
          self.getInvSuccess(returnList);
        })
        .catch(function (err) { console.log('err: ', err); }); // eslint-disable-line no-console
    }
  },

  getInvSuccess: function (response) {
    var self = this;

    if (response.length) {
      $('.available-inventory-section').show();
      for (var i = 0; i < response.length; i += 1) {
        response[i].localId = i;
      }
      __additionalInventoryItems = response; // [];

      // Modifying the __additionalInventoryItems array in place
      var card;
      var exname;
      var tokens;
      var newtitle;
      var features;
      var modelsUsed = [];

      for (var j = 0; j < __additionalInventoryItems.length; j += 1) {
        card = __additionalInventoryItems[j].card;
        modelsUsed.push(card.modelcode);
        card.dataLayer.list_item_index = (j + 1).toString(); // BAT-3445 add list_item_index to DL.
        card.dataLayer.link_text = card.name;
        exname = card.color.exterior.name;
        tokens = exname.split(' ');
        // ADD TITLE WITH LINE BREAK THAT ONLY GETS USED IN THE md ( tablet / ipad ) breakpoint.
        newtitle = '<span>' + tokens[0] + '</span><br class="hidden-lg hidden-sm"/> <span>' + tokens.slice(1).join(' ') + '</span>';
        card.color.exterior.name = newtitle;
        // AND PARENT INDEX FOR FEATURE CHILD ITEMS.
        features = __additionalInventoryItems[j].features;

        for (var f = 0; f < features.length; f += 1) {
          features[f].parentIndex = String((j + 1));
        }
      }

      var params = {
        filter: {
          year: [__seriesYear],
          series: [__offerSeries],
          region: [__regionCode],
          model: modelsUsed
        },
        pagesize: 1
      };

      inventoryService.inventory().getInventory(params)
        .then(function (res) {
          // create disclaimerMap from these grouped disclaimers
          var alreadyUsedDisclaimerArray = [];
          var tempDisclaimersObj = res.body.response.disclaimers;
          var finalDisclaimersObj = {};
          var staticOffset = (document.getElementById('disclaimers-global-modal').outerHTML.match(/static-disclaimer/g) || []).length;
          var count = 0;

          if (tempDisclaimersObj !== null) {
            Object.keys(tempDisclaimersObj).forEach(function (key) {
              var textValue = tempDisclaimersObj[key].description;
              var codeValue = tempDisclaimersObj[key].code;
              var symbolValue = count + staticOffset + 1;

              finalDisclaimersObj[tempDisclaimersObj[key].code] = {
                symbol: symbolValue, // CREATES THE NUMBER SYMBOL USED LATER TO DRAW.
                code: codeValue,
                description: textValue
              };

              // ADD DISCLAIMER ELEMENTS TO DOM, WHICH GETS PROCESSED BY disclaimerService
              if (alreadyUsedDisclaimerArray.indexOf(codeValue) === -1) {
                var span = '<span class="js-disclaimer-local-content" data-id="' + key + '" data-disclaimer-content="' + textValue + '"></span>';
                $('body').append(span);
                alreadyUsedDisclaimerArray.push(codeValue);
              }
              count += 1;
            });

            disclaimersService.addLocalDisclaimers();
          }

          self.cachedDisclaimerMap = finalDisclaimersObj;
          // PROCESS ELEMENT GROUPINGS THAT MAY HAVE DISCLAIMERS.
          self.processDisclaimersBySelector('.feature-content li');

          // No longer doing offer-detail things from down here. We shall see
          // self.processDisclaimersBySelector('.offer-image-disclaimer p');
          // self.processDisclaimersBySelector('.offer-detail-details .container .details p');
          // TOP DETAILS TO BE SHOWN AFTER DISCLAIMERS ARE PROCESSED.
          // $('.offer-detail-details .container .details').addClass('visible');
        }, function (error) {
          console.log(' ::: GET VEHCILE FOR DISCLAIMERS ERROR', error); // eslint-disable-line no-console
        });
    }
    self.drawAdditionalInventoryItems(__additionalInventoryItems);
  },

  drawAdditionalInventoryItems: function (inventoryItems) {
    var self = this;

    $('#availableInventoryOutput').html(__tmplInv({
      i18n: self.i18n,
      items: inventoryItems
    }));

    if (responsive() === 'sm') {
      self.drawAdditionalInventorySlideshow(inventoryItems);
    } else {
      self.drawAdditionalInventoryList();
    }
  },

  drawAdditionalInventoryList: function () {
    var self = this;
    if (__availableListlistDrawn) return;
    try {
      // ONLY SHOW 4 to start with the option to show more, 2 at a time.
      self.viewMoreAdditional();
      self.cardToggling();
      enableFeatureExpanders();
      $('.view-more-additional').on('click', function () {
        switch (__additionalInventoryDisplayCount) {
          case 4:
            __additionalInventoryDisplayCount = 6;
            break;
          case 6:
            __additionalInventoryDisplayCount = 8;
            $(this).addClass('remove');
            break;
          default: break;
        }
        self.viewMoreAdditional();
      });
      $('.view-more-additional').addClass('viewable');
      self.buildCtas($('#availableInventoryOutput'));
      self.analytics();
      __availableListlistDrawn = true;
    } catch (error) {
      console.log('ERROR ', error); // eslint-disable-line no-console
    }
  },

  cardToggling: function () {
    var toggleCard = function (offerCard) {
      var expanding;
      var uparrow = $(offerCard).find('.card-expander .icon-arrow-up');
      var downarrow = $(offerCard).find('.card-expander .icon-arrow-down');
      uparrow.toggleClass('active');
      downarrow.toggleClass('active');

      if ($(offerCard).hasClass('expanded-height')) {
        expanding = false;
        offerCard.removeClass('expanded-height');
      } else {
        expanding = true;
        offerCard.addClass('expanded-height');
      }

      var expansion = $(offerCard).find('.card-expansion');
      var featureHeaders = expansion.find('.expansion-wrap').find('.feature-header');
      var ewrow = expansion.find('.expansion-wrap').find('.row');

      if (expanding) {
        $(offerCard).addClass('expanded-height');
        ewrow.removeClass('animate-out').addClass('animate');
        // FEATURE HEADERS.
        setTimeout(function () {
          featureHeaders.each(function (index, item) {
            var timeouttime = index * 250;
            setTimeout(function () {
              $(item).removeClass('animate-out').addClass('animate');
            }, timeouttime);
          });
        }, 350);
      } else {
        // COLLAPSE:
        featureHeaders.each(function (index, item) {
          var timeouttime = 150;
          setTimeout(function () {
            $(item).removeClass('animate').addClass('animate-out');
          }, timeouttime);
        });
        ewrow.removeClass('animate').addClass('animate-out');
        offerCard.removeClass('expanded-height');
      }
    };

    // CAPTRUE CARD CLICKS. ONLY PASS EVENTS THAT ARE LESS THAN THE HEIGHT OF THE CLOSED VERSION OF THE CARD.
    $('.offer-inventory-card').on('click', function (event) {
      var oCard = $(this);
      var yPos = event.pageY - oCard.offset().top;
      if (yPos > 149) {
        return; // DO NOT PASS THRU.
      }
      toggleCard(oCard);
    });
  },

  viewMoreAdditional: function () {
    $('.offer-inventory-card').each(function (index, item) {
      if (index < __additionalInventoryDisplayCount && !$(item).hasClass('viewable')) {
        $(item).addClass('viewable');
      }
    });
  },

  drawAdditionalInventorySlideshow: function () {
    var self = this;
    try {
      var additional_slider = new Slicker({ // eslint-disable-line no-unused-vars
        $slider: $('.available-inventory-carousel'),
        slickOptions: {
          mobileFirst: true,
          slide: '.offer-inventory-card-mob',
          dots: true,
          arrows: true,
          centerMode: true,
          centerPadding: '50px',
          paddingBottom: '60px',
          slidesToShow: 1,
          infinite: false,
          initialSlide: 3,
          initFunction: function () {
            // HIDE PLACEHOLDES ON IMG LOAD:
            $('.available-inventory-carousel .jelly').each(function (idx, item) {
              var img = $(item).find('img');
              img.on('load', function () {
                $(item).addClass('loaded');
              });
            });

            self.buildCtas($('.offer-detail-inventory-modal'));
            function slideClick(event) {
              var currentTarget = $(event.currentTarget);
              var localId = Number(currentTarget.attr('data-localId'));
              var store = __additionalInventoryItems;
              var selectedItem = {};
              for (var i = 0; i < store.length; i += 1) {
                if (localId === store[i].localId) {
                  selectedItem = store[i];
                  break;
                }
              }
              if (!$.isEmptyObject(selectedItem)) {
                $('#modalOutput').html(__tmplInvModal({
                  data: selectedItem,
                  allCards: store,
                  i18n: self.i18n,
                }));
                $('#additional-inventory-modal').modal('show');
                $('.offer-detail-inventory-modal .feature-expander').each(function (index, item) {
                  $(item).on('click', function () {
                    $(item).find('.icon-arrow-up').toggleClass('active');
                    $(item).find('.icon-arrow-down').toggleClass('active');
                    var expansion = $(this).parents().find('.feature-content').eq(index);
                    expansion.toggleClass('expanded');
                  });
                });
                // HANDLE MODAL DISCLAIMERS
                self.processDisclaimersBySelector('.od-modal-details .feature-content li');
              }
            }

            $('.slick-slider').on('click', '.slick-slide', slideClick);
          }
        }
      });
      __additionalInventoryDisplayCount = 8;
      self.viewMoreAdditional();
    } catch (error) {
      console.log('  ::: slide show ERROR ::: ', error); // eslint-disable-line no-console
    }
  },

  processDisclaimersBySelector: function (selectorString) {
    var self = this;
    var $pees = $(selectorString);
    var htmlstring;

    $pees.each(function (idx, item) {
      htmlstring = $(item).html();
      var matched = htmlstring.match(__regexDisclaimer);
      if (matched) {
        htmlstring = htmlstring.replace(__regexDisclaimer, function (match, p1, p2) {
          var disItem = self.cachedDisclaimerMap[p2];
          if (!match || !p2 || !disItem) {
            return '<span class="color-red">' + match + '</span>';
          }
          disItem = self.cachedDisclaimerMap[p2];
          return '<sup class="color-red footnote od-footnote"><a href="#" class="js-disclaimer-local" data-disclaimer-id="' + disItem.symbol + '">' + disItem.symbol + '</a></sup>';
        });
        $(item).html(htmlstring);
      }
    });

    $('.js-disclaimer-vi').off().on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      disclaimersService.handleDisclaimers('static', $(e.target).text());
    });
  },

  analytics: function () {
    var $componentEl = $('#availableInventoryOutput');

    anAddContext(
      $componentEl,
      blocks.sectionBlock('Available Inventory'),
      // default generic series data
      blocks.seriesBlock({
        series_code: __offerSeries,
        grade: __additionalInventoryItems[0].card.trim,
        year: __seriesYear
      })
    );

    // context on each .offer-inventory-card added via inline HBS.
    // Shite or yaaay?
    anClicks($componentEl);

    scroll.add($componentEl, {
      after: function viewAfter() {
        anComponentView($componentEl);
      }
    });
  },

  buildCtas: function ($scope) {
    raq(this.currentOffer.id, $scope);
    compare(__seriesYear, __offerSeries, $scope);
    dealerSite($scope);
    inventory({
      series: __offerSeries,
      grade: __additionalInventoryItems[0].card.trim,
      year: __seriesYear
    }, $scope);
    dealBuilder(__seriesYear, __offerSeries, $scope);
    offers(__offerSeries, $scope);
  }
};

export default additionalInventory;

